import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Chip,
  Select,
  TextField,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import "./clientscreate.css";
import { GetUserInfo } from "../../../_utilities/getUserInfo";
import CkEditor from "../../../components/CkEditor/CkEditor";
import OutlinedInput from "@mui/material/OutlinedInput";
const initialDetails = {
  clientName: "",
  location: "",
  contactName: "",
  phoneNumber: "",
  managerEmail: "",
  websiteURL: "",
  isContractSigned: "",
  region: "",
  status: "1",
  notes: "",
  // client_id: "",
};

const initClients = JSON.parse(JSON.stringify(initialDetails));

const phoneRegExp = /^[0-9()+-\s\b]*$/;

const validationSchema = Yup.object({
  clientName: Yup.string()
    .min(1, "Must be 1 characters")
    .max(50, "Must be less than 50 ")
    .required("Please enter a client's name"),
  region: Yup.string().required("Please select the region"),
  isContractSigned: Yup.string().required("Please select the contract status"),
  status: Yup.string().required("Please select a status from the dropdown"),
  location: Yup.string().required("Please enter location"),
  websiteURL: Yup.string()
    .matches(
      /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-z]{2,20}(\/.*)?$/,
      "Please enter a valid website URL",
    )
    .required("Please enter a website URL"),
  phoneNumber: Yup.string()
    .matches(
      phoneRegExp,
      "Invalid phone number format. Please enter a valid number",
    )
    .min(10, "must be 10 characters")
    .max(20, "must be less than 20"),
  managerEmail: Yup.string().email("Invalid email address"),
  contactName: Yup.string()
    .min(1, "Must be 1 characters")
    .max(50, "Must be less than 50 "),
});

const ClientsComponent = ({
  componentType = "Create",
  actions,
  onValidData,
  input,
  iniValue,
  customFieldsArray = null,
  disableBtn,
  onClose,
}) => {
  const [countries, setCountries] = useState([]);
  const [getcustomFields, setGetCustomFields] = useState(null);

  const navigate = useNavigate();

  // Build errors for mandatory custom fields
  const validateMandatoryCustomFields = (fieldsArray = [], valuesObj = {}) => {
    const cfErrors = {};
    const safeFieldsArray = Array.isArray(fieldsArray) ? fieldsArray : [];
    const safeValuesObj = valuesObj || {};

    safeFieldsArray.forEach((f) => {
      if (Number(f.mandatory) !== 1) return; // only required
      const key = f.fieldName;
      const dt = (f.dataType || "").toLowerCase().trim();
      const v = safeValuesObj[key];

      if (dt === "text box") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "single select") {
        if (v == null || String(v).trim() === "") cfErrors[key] = "Required";
      } else if (dt === "multi select") {
        if (!Array.isArray(v) || v.length === 0)
          cfErrors[key] = "Select at least one option";
      }
    });
    return cfErrors;
  };

  const formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initClients)),
    validationSchema,
    validate: (values) => {
      const errors = {};
      // uses latest customFieldsArray + getcustomFields from this render
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray || [],
        getcustomFields || {},
      );
      if (Object.keys(cfErrors).length) {
        errors.customFields = cfErrors;
      }
      return errors;
    },
    onSubmit: async (values) => {
      const cfErrors = validateMandatoryCustomFields(
        customFieldsArray || [],
        getcustomFields || {},
      );
      if (Object.keys(cfErrors).length > 0) {
        const element = document.querySelector(".clients-component-container");
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
        formik.setErrors((prev) => ({
          ...(prev || {}),
          customFields: cfErrors,
        }));
        formik.setTouched(
          (prev) => ({
            ...(prev || {}),
            customFields: Object.fromEntries(
              Object.keys(cfErrors).map((k) => [k, true]),
            ),
          }),
          true,
        );
        return;
      }
      let userData = await GetUserInfo();
      const customFields = Object.entries(getcustomFields || {}).map(
        ([key, value]) => ({
          key: key,
          value: value,
        }),
      );
      const payload = {
        ...values,
        userId: userData[0].userId,
        customFields: customFields,
      };
      onValidData(payload);
    },
  });

  useEffect(() => {
    async function init() {
      if (componentType === "Create") {
        formik.setFieldValue("status", "1");
      }
      let userData = await GetUserInfo();
      let userCountries = JSON.parse(userData[0].selectedcountries);
      setCountries(userCountries);
    }
    init();
  }, [componentType]);

  // Synchronize input prop with Formik only when it actually changes or on mount
  useEffect(() => {
    let baseValues = {};
    if (input && Object.keys(input).length > 0) {
      const customFields = input?.customFields
        ? JSON.parse(input.customFields)
        : [];
      const result = customFields.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {});
      console.log("Parsed custom fields for form initialization:", result);
      setGetCustomFields(result);
      delete input.customFields;
      baseValues = {
        ...initialDetails,
        ...input,
      };
    } else if (componentType === "Create") {
      baseValues = JSON.parse(JSON.stringify(initClients));
      baseValues.status = "1";
    }
    if (Object.keys(baseValues).length > 0) {
      formik.setValues(baseValues);
    }
  }, [input, componentType]);

  const onChangeHandler = (value, type) => {
    if (type === "managerEmail") {
      value = value.trim();
    }
    if (type === "phoneNumber") {
      value = value.replace(/\D/g, "");
    }
    value = typeof value === "string" ? value.trimStart() : value;
    formik.setFieldValue(type, value);
  };

  const onUpdateCkEditor = (obj) => {
    formik.setFieldValue("notes", obj.data);
  };

  const onChangeCustomFieldsHandler = (value, type) => {
    setGetCustomFields((prevousValue) => ({ ...prevousValue, [type]: value }));
  };

  return (
    <Box
      className="clients-component-container"
      sx={{ p: 0, position: "relative", minHeight: "calc(100vh - 100px)" }}
    >
      <FocusError formik={formik} />
      <div
        className={
          componentType === "view"
            ? "viewSection client-form-content"
            : "client-form-content"
        }
        style={{ padding: "16px" }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              fullWidth
              className="boldlabel"
              error={formik.errors.clientName && formik.touched.clientName}
              helperText={formik.touched.clientName && formik.errors.clientName}
              variant="outlined"
              label="Client Name*"
              value={formik.values.clientName}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => onChangeHandler(e.target.value, "clientName")}
              disabled={componentType === "view"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              size="small"
              fullWidth
              error={formik.errors.status && formik.touched.status}
            >
              <InputLabel shrink className="boldSelectlabel">
                Status*
              </InputLabel>
              <Select
                value={formik.values.status}
                label="Status*&nbsp;&nbsp;"
                onChange={(e) => onChangeHandler(e.target.value, "status")}
                disabled={componentType === "view"}
                style={{ borderRadius: "4px" }}
              >
                <MenuItem className="selectOptions" value="1">
                  Active
                </MenuItem>
                <MenuItem className="selectOptions" value="0">
                  Inactive
                </MenuItem>
              </Select>
              {formik.touched.status && formik.errors.status && (
                <FormHelperText>{formik.errors.status}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              fullWidth
              className="boldlabel"
              error={formik.errors.location && formik.touched.location}
              helperText={formik.touched.location && formik.errors.location}
              variant="outlined"
              label="Location*"
              value={formik.values.location}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => onChangeHandler(e.target.value, "location")}
              disabled={componentType === "view"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              fullWidth
              className="boldlabel"
              error={formik.errors.contactName && formik.touched.contactName}
              helperText={
                formik.touched.contactName && formik.errors.contactName
              }
              variant="outlined"
              label="Contact Name"
              value={formik.values.contactName}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => onChangeHandler(e.target.value, "contactName")}
              disabled={componentType === "view"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              fullWidth
              className="boldlabel"
              error={formik.errors.phoneNumber && formik.touched.phoneNumber}
              helperText={
                formik.touched.phoneNumber && formik.errors.phoneNumber
              }
              variant="outlined"
              label="Phone Number"
              value={formik.values.phoneNumber}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => onChangeHandler(e.target.value, "phoneNumber")}
              disabled={componentType === "view"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              fullWidth
              className="boldlabel"
              error={formik.errors.managerEmail && formik.touched.managerEmail}
              helperText={
                formik.touched.managerEmail && formik.errors.managerEmail
              }
              variant="outlined"
              label="Email ID"
              value={formik.values.managerEmail}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => onChangeHandler(e.target.value, "managerEmail")}
              disabled={componentType === "view"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              fullWidth
              className="boldlabel"
              error={formik.errors.websiteURL && formik.touched.websiteURL}
              helperText={formik.touched.websiteURL && formik.errors.websiteURL}
              variant="outlined"
              label="Website*"
              value={formik.values.websiteURL}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => onChangeHandler(e.target.value, "websiteURL")}
              disabled={componentType === "view"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              size="small"
              fullWidth
              error={
                formik.errors.isContractSigned &&
                formik.touched.isContractSigned
              }
            >
              <InputLabel shrink className="boldSelectlabel">
                Contract Signed*
              </InputLabel>
              <Select
                value={formik.values.isContractSigned}
                label="Contract Signed*&nbsp;&nbsp;"
                onChange={(e) =>
                  onChangeHandler(e.target.value, "isContractSigned")
                }
                disabled={componentType === "view"}
                style={{ borderRadius: "4px" }}
              >
                <MenuItem className="selectOptions" value="Yes">
                  Yes
                </MenuItem>
                <MenuItem className="selectOptions" value="No">
                  No
                </MenuItem>
                <MenuItem className="selectOptions" value="In negotiation">
                  In negotiation
                </MenuItem>
              </Select>
              {formik.touched.isContractSigned &&
                formik.errors.isContractSigned && (
                  <FormHelperText>
                    {formik.errors.isContractSigned}
                  </FormHelperText>
                )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl
              size="small"
              fullWidth
              error={formik.errors.region && formik.touched.region}
            >
              <InputLabel shrink className="boldSelectlabel">
                Region*
              </InputLabel>
              <Select
                value={formik.values.region}
                label="Region*&nbsp;&nbsp;"
                onChange={(e) => onChangeHandler(e.target.value, "region")}
                disabled={componentType === "view"}
                style={{ width: "100%", borderRadius: "4px" }}
              >
                {countries.map((list) => (
                  <MenuItem
                    className="selectOptions"
                    key={list.id}
                    value={list.name}
                  >
                    {list.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.region && formik.errors.region && (
                <FormHelperText>{formik.errors.region}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          {/* customFields Ui render start here */}
          {customFieldsArray &&
            customFieldsArray.length > 0 &&
            customFieldsArray.map((data, index) => {
              const err = formik.errors?.customFields?.[data.fieldName];
              const touched = formik.touched?.customFields?.[data.fieldName];
              const hasError = Boolean(
                err && (touched || formik.submitCount > 0),
              );
              const isReq = Number(data.mandatory) === 1;

              if (data.dataType.toLowerCase().trim() === "text box") {
                return (
                  <Grid item xs={12} md={6}>
                    <TextField
                      className="boldlabel"
                      id={data.fieldName}
                      variant="outlined"
                      autoComplete="off"
                      style={{ width: "100%" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label={`${data.fieldName}${Number(data.mandatory) === 1 ? " *" : ""}`}
                      error={hasError}
                      helperText={hasError ? err : ""}
                      name={`customFields.${data.fieldName}`}
                      disabled={componentType === "view" ? true : false}
                      value={getcustomFields?.[data.fieldName] ?? ""}
                      onChange={(e) =>
                        onChangeCustomFieldsHandler(
                          e.target.value,
                          data.fieldName,
                        )
                      }
                      onBlur={formik.handleBlur}
                    />
                  </Grid>
                );
              } else if (
                data.dataType.toLowerCase().trim() === "multi select"
              ) {
                return (
                  <Grid item xs={12} md={6}>
                    <FormControl
                      sx={{ width: "100%" }}
                      fullWidth
                      error={hasError}
                      required={isReq}
                    >
                      <InputLabel
                        className="boldSelectlabel"
                        shrink={true}
                        id={`${data.fieldName}-label`}
                      >
                        {data.fieldName}
                      </InputLabel>
                      <Select
                        labelId={`${data.fieldName}-label`}
                        id={`${data.fieldName}-select`}
                        multiple
                        name={`customFields.${data.fieldName}`}
                        disabled={componentType === "view" ? true : false}
                        value={
                          Array.isArray(getcustomFields?.[data.fieldName])
                            ? getcustomFields[data.fieldName]
                            : []
                        }
                        onChange={(e) =>
                          onChangeCustomFieldsHandler(
                            e.target.value,
                            data.fieldName,
                          )
                        }
                        onBlur={formik.handleBlur}
                        input={
                          <OutlinedInput
                            id={`select-multiple-chip-${data.fieldName}`}
                            label={data.fieldName}
                          />
                        }
                        renderValue={(selected) => {
                          if (typeof selected === "string") return selected;
                          const visibleItems = selected.slice(0, 2);
                          const remainingCount = selected.length - 2;
                          return (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                                maxHeight: "65px",
                                overflowX: "auto",
                              }}
                            >
                              {visibleItems.map((value) => (
                                <Chip key={value} label={value} />
                              ))}
                              {remainingCount > 0 && (
                                <span style={{fontSize: "13px", padding: "5px 0 5px 7px"}}>{`+${remainingCount}`}</span>
                              )}
                            </Box>
                          );
                        }}
                      >
                        {data?.customValues &&
                          data.customValues.length > 0 &&
                          data.customValues.map((name) => (
                            <MenuItem
                              className="selectOptions"
                              key={name}
                              value={name}
                            >
                              {name}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>{hasError ? err : ""}</FormHelperText>
                    </FormControl>
                  </Grid>
                );
              } else if (
                data.dataType.toLowerCase().trim() === "single select"
              ) {
                return (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth error={hasError} required={isReq}>
                      <InputLabel
                        className="boldSelectlabel"
                        id={`${data.fieldName}-label`}
                        shrink={true}
                      >
                        {data.fieldName}
                      </InputLabel>
                      <Select
                        name={`customFields.${data.fieldName}`}
                        labelId={`${data.fieldName}-label`}
                        label={data.fieldName}
                        id={`${data.fieldName}-select`}
                        autoComplete="off"
                        value={getcustomFields?.[data.fieldName] ?? ""}
                        variant="outlined"
                        style={{
                          width: "100%",
                          height: "3.5rem",
                          borderRadius: "4px",
                        }}
                        onChange={(e) =>
                          onChangeCustomFieldsHandler(
                            e.target.value,
                            data.fieldName,
                          )
                        }
                        onBlur={formik.handleBlur}
                        disabled={componentType === "view" ? true : false}
                      >
                        {data?.customValues &&
                          data.customValues.length > 0 &&
                          data.customValues.map((name) => {
                            return (
                              <MenuItem className="selectOptions" value={name}>
                                {name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <FormHelperText>{hasError ? err : ""}</FormHelperText>
                    </FormControl>
                  </Grid>
                );
              }
            })}
        </Grid>

        <Box sx={{ mt: 4 }}>
          <Typography
            variant="body1"
            className="boldlabel"
            sx={{ mb: 1, textAlign: "left" }}
          >
            Client Notes
          </Typography>
          <CkEditor
            data={formik.values.notes}
            onUpdatehandler={onUpdateCkEditor}
            isReadonly={componentType === "view"}
          />
        </Box>

        {(componentType === "Create" || componentType === "Edit") && (
          <Box
            id="clientsbuttons"
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              backgroundColor: "var(--secondary-bg-color)",
              padding: "15px 20px",
              margin: "40px -16px -16px -16px",
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
            }}
          >
            <Button
              variant="text"
              className="clientcancelbtn"
              onClick={() =>
                onClose ? onClose() : navigate("/ats/layout/clients/landing")
              }
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="clientssubmitbtn"
              type="submit"
              size="small"
              disabled={disableBtn}
              onClick={formik.handleSubmit}
            >
              {componentType === "Edit" ? "Update" : "Save"}
            </Button>
          </Box>
        )}
      </div>
    </Box>
  );
};

export default ClientsComponent;
